// @ts-nocheck
import { CrmRelationType } from '../models/CrmRelationType';

export class QueryManagerHelper {
  static appendQueryParameter(parameterName: string, parameterValue: string) {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);
    searchParams.set(parameterName, parameterValue);
    currentUrl.search = searchParams.toString();
    window.history.replaceState({}, '', currentUrl.toString());
  }

  static getParameterValue(parameterName: string) {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);
    return searchParams.get(parameterName);
  }

  static getEntityTypeFromQuery() {
    const section = window.location.href.split('?')[0];
    let entityType = CrmRelationType.CrmRelation;

    if (section.includes('board')) entityType = CrmRelationType.Task;
    else if (section.includes('projects')) entityType = CrmRelationType.Project;

    return entityType;
  }
}
